import React, { Component } from "react";
import { reduxForm } from "redux-form";
import { Col, Row } from "react-bootstrap";

import FormButton from "common/components/FormButton";
import { TextField, TextAreaField } from "common/components/forms/inputs";

const formName = "attorneyNotes";

class AttorneyNotesForm extends Component {
  render() {
    const { handleSubmit, pristine, submitting, valid } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col sm={8}>
            <TextAreaField name="notes" label="Notes" rows={4} />
          </Col>
          <Col sm={4}>
            <TextField name="year_first_admitted" label="Year First Admitted" />
            <FormButton
              action="save"
              submitting={submitting}
              disabled={pristine || submitting || !valid}
              className="pull-right"
              block
            />
          </Col>
        </Row>
      </form>
    );
  }
}

export default reduxForm({
  form: formName,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(AttorneyNotesForm);
